// Dictionary of human-readable counter parts for certain terms

const dictionary = {
  FreeOfCharge: 'maksuton',
  Chargeable: 'maksullinen',
  Monday: 'MA',
  Tuesday: 'TI',
  Wednesday: 'KE',
  Thursday: 'TO',
  Friday: 'PE',
  Saturday: 'LA',
  Sunday: 'SU',
  ruotsi: 'myös ruotsiksi',
  englanti: 'myös englanniksi',
  Location: 'Käyntiosoite',
  Postal: 'Postiosoite',
};

const translate = (input) => dictionary[input] || input;

export default translate;
